import { Component, OnInit } from '@angular/core';
import { FormGroup, Validator, FormBuilder, Validators } from '@angular/forms'
import { Request } from '../_service/request';
import { ActivatedRoute, Params, Router } from '@angular/router';


@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private request: Request,
    private router: Router,
  ) { }
  selectionErr = false;
  contactSubmitted = false;
  roomCount: any = "";
  budgetCount: any = "";
  getContactform: FormGroup;
  ngOnInit(): void {
    this.getContactform = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern('[a-zA-Z ]{1,15}')]],
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9.]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobile: ['', [Validators.required, Validators.pattern('[0-9]{1,15}$')]],
      message: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9 ]{1,50}$')]],
      city: ['', [Validators.required, Validators.pattern('[a-zA-Z ]{1,15}$')]],
      country: ['', [Validators.required, Validators.pattern('[a-zA-Z ]{1,15}$')]],
      state: ['', [Validators.required, Validators.pattern('[a-zA-Z ]{1,15}$')]],
    })
  }

  get ctc() { return this.getContactform.controls; }


  getBedRoomCount(count) {
    console.log(count)
    this.roomCount = count;
  }

  getBudget(count) {
    console.log(count)
    this.budgetCount = count;
  }

  isMailSent = false;
  async OnsubmitingContactForm() {
    console.log('clicked')
    this.contactSubmitted = true;
    if (this.getContactform.invalid) {
      console.log('invalid')
      return;
    } else {
      console.log(this.getContactform.value);
      if (this.roomCount == "" || this.budgetCount == "") {
        this.selectionErr = true;
        setTimeout(() => {
          this.selectionErr = false
        }, 3000);
      } else {
        this.selectionErr = false
        let temp = this.request.get_structure('contact_mail', 'format')
        temp.name = this.getContactform.value.name,
          temp.email = this.getContactform.value.email
        temp.mobile = Number(this.getContactform.value.mobile)
        temp.city = this.getContactform.value.city
        temp.state = this.getContactform.value.state
        temp.country = this.getContactform.value.country
        temp.message = this.getContactform.value.message
        temp.bedroom = Number(this.roomCount)
        temp.budget = Number(this.budgetCount)
        console.log(temp);
        temp = await this.request.post(0, 'contact_mail', temp)
        console.log(temp)
        if (temp[0] == 200) {
          this.isMailSent = true;
          this.contactSubmitted = false;
          this.getContactform = this.formBuilder.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9.]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            mobile: [Number, [Validators.required]],
            message: ['', [Validators.required]],
            city: ['', [Validators.required]],
            country: ['', [Validators.required]],
            state: ['', [Validators.required]],
          })
          setTimeout(() => {
            this.isMailSent = false;
            window.location.reload()
          }, 5000);
        }
      }
    }
  }


}
